module.exports = __webpack_public_path__ + "img/canaltech.a7fbd26a.webp";